import { Component, ViewEncapsulation } from '@angular/core';
import { Router, Route } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {
  menuItems: any[] = [];

  constructor(private router: Router) {
    this.generateMenuItemsFromRoutes();
  }

  generateMenuItemsFromRoutes(): void {
    const excludedPaths = ['login', 'register', '2fa', 'reset'];
    const routes = this.router.config;

    const filtered = routes
      .filter((route) =>
        !!route.data?.navTitle && !excludedPaths.includes(route.path || '')
      )
      .map((route) => {
        const basePath = `/${route.path}`;
        const children = (route.children || [])
          .filter((child) => child.data?.navTitle)
          .map((child) => {
            const childPath = `${basePath}/${child.path}`;

            // Check if this child has grandchildren (3rd level)
            const grandchildren = (child.children || [])
              .filter((grandchild) => grandchild.data?.navTitle)
              .map((grandchild) => ({
                title: grandchild.data?.navTitle,
                link: `${childPath}/${grandchild.path}`,
              }));

            return {
              title: child.data?.navTitle,
              link: grandchildren.length ? undefined : childPath,
              children: grandchildren.length ? grandchildren : undefined,
              hasChildren: grandchildren.length > 0
            };
          });

        return {
          title: route.data!.navTitle,
          icon: route.data?.icon || 'ki-chart-pie-3',
          type: children.length ? 'accordion' : 'single',
          link: children.length ? undefined : basePath,
          basePath: basePath,
          children: children.length ? children : undefined,
        };
      });

    this.menuItems = filtered;
  }

  isActiveRoute(basePath?: string): boolean {
    if (!basePath) return false;
    return this.router.url === basePath || this.router.url.startsWith(basePath + '/');
  }
}
